import React from "react";
import { useDispatch } from "react-redux";
import { ShownValuesTypes } from "./types";
import { InsRadioGroup } from "components";
import { useShownValues, useWidgetChildrenId, useWidgetCurrentDisplayValueType, useWidgetCurrentSortBy } from "components/widgets/hooks/use-current-widget";
import { appInsightEvents, language } from "language/default";
import { appInsightsTrackEvent } from "plugins/app-insight-init";
import { setCurrentStatusShownValues } from "store/current-dashboard";
import { SortByTypes } from "store/current-dashboard/types";
import { getCurrentLocalTime } from "common/date-utils";
const dropdownOptions = [
    {
        values: [
            { displayValue: "3%", isSelected: true, value: 3 },
            { displayValue: "4%", value: 4 },
            { displayValue: "5%", value: 5 },
            { displayValue: "6%", value: 6 },
            { displayValue: "7%", value: 7 },
            { displayValue: "8%", value: 8 }
        ]
    }
];
const shownLabels = language.en.skeleton.settingsMenu.shownValues;
const radioOptions = [
    { label: shownLabels.all, value: { filter: ShownValuesTypes.All } },
    { label: shownLabels.biggerThan, selectData: dropdownOptions, value: { filter: ShownValuesTypes.BiggerThan } },
    { label: shownLabels.top5, value: { filter: ShownValuesTypes.Top, quantity: 5 } },
    { label: shownLabels.top10, value: { filter: ShownValuesTypes.Top, quantity: 10 } },
    { label: shownLabels.bottom5, value: { filter: ShownValuesTypes.Bottom, quantity: 5 } },
    { label: shownLabels.bottom10, value: { filter: ShownValuesTypes.Bottom, quantity: 10 } }
];
export const InsSettingsSelectedValues = ({ widgetId, sectionId }) => {
    const childrenId = useWidgetChildrenId(sectionId, widgetId), dispatch = useDispatch(), displayValueType = useWidgetCurrentDisplayValueType(sectionId, widgetId), shownValues = useShownValues(sectionId, widgetId), sortedBy = useWidgetCurrentSortBy(sectionId, widgetId);
    const radioData = radioOptions
        .filter((key) => key.value.filter !== ShownValuesTypes.BiggerThan || displayValueType)
        .map((key) => ({
        checked: key.value.filter === shownValues?.filter && (!key.value.quantity || key.value.quantity === shownValues?.quantity),
        disabled: false,
        eventData: key.value,
        label: key.label,
        selectData: key.selectData
    }));
    const handleRadioChange = (event) => {
        appInsightsTrackEvent({ name: appInsightEvents.customEvents.names.ChangeWidgetSettingsShowSubset,
            properties: { LocalTimestamp: getCurrentLocalTime() } }, {
            selectedSubset: event?.detail?.value?.label
        });
        dispatch(setCurrentStatusShownValues({ childrenId, sectionId, shownValues: event?.detail?.value?.eventData || { filter: ShownValuesTypes.All }, widgetId }));
    };
    return React.createElement(InsRadioGroup, { label: shownLabels.label, data: radioData, isHeaderBold: true, disabled: sortedBy !== SortByTypes.Value, onRadioChanged: handleRadioChange });
};
